// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/chat/attachment.proto (package qliq_protobuf.chat, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { QuickForm } from "./quick_form_pb.ts";
import { FormSubmission } from "./form_submission_pb.ts";
import { Faq } from "../faq_pb.ts";
import { QuickSignDocument } from "../quick_sign_document_pb.ts";

/**
 * @generated from message qliq_protobuf.chat.Attachment
 */
export class Attachment extends Message<Attachment> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string thumbnail_url = 2;
   */
  thumbnailUrl = "";

  /**
   * @generated from field: string url = 3;
   */
  url = "";

  /**
   * @generated from field: string content_type = 4;
   */
  contentType = "";

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt = "";

  /**
   * @generated from field: string iv = 6;
   */
  iv = "";

  /**
   * @generated from field: string inline = 7;
   */
  inline = "";

  /**
   * @generated from field: string key = 8;
   */
  key = "";

  /**
   * @generated from field: bool encrypt_attachments = 9;
   */
  encryptAttachments = false;

  /**
   * there was oneof but removed due to weird ruby parser error
   *
   * @generated from field: qliq_protobuf.chat.QuickForm form = 10;
   */
  form?: QuickForm;

  /**
   * @generated from field: qliq_protobuf.chat.FormSubmission form_submission = 11;
   */
  formSubmission?: FormSubmission;

  /**
   * @generated from field: qliq_protobuf.Faq faq = 12;
   */
  faq?: Faq;

  /**
   * @generated from field: string file_name = 13;
   */
  fileName = "";

  /**
   * @generated from field: string data_url = 14;
   */
  dataUrl = "";

  /**
   * whether to show preview for faq attacments
   *
   * @generated from field: bool should_expand = 15;
   */
  shouldExpand = false;

  /**
   * @generated from field: qliq_protobuf.chat.Attachment.Booking booking = 16;
   */
  booking?: Attachment_Booking;

  /**
   * @generated from field: qliq_protobuf.QuickSignDocument quick_sign_document = 17;
   */
  quickSignDocument?: QuickSignDocument;

  constructor(data?: PartialMessage<Attachment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.Attachment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "thumbnail_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "iv", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "inline", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "encrypt_attachments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "form", kind: "message", T: QuickForm },
    { no: 11, name: "form_submission", kind: "message", T: FormSubmission },
    { no: 12, name: "faq", kind: "message", T: Faq },
    { no: 13, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "data_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "should_expand", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "booking", kind: "message", T: Attachment_Booking },
    { no: 17, name: "quick_sign_document", kind: "message", T: QuickSignDocument },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Attachment {
    return new Attachment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Attachment {
    return new Attachment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Attachment {
    return new Attachment().fromJsonString(jsonString, options);
  }

  static equals(a: Attachment | PlainMessage<Attachment> | undefined, b: Attachment | PlainMessage<Attachment> | undefined): boolean {
    return proto3.util.equals(Attachment, a, b);
  }
}

/**
 * @generated from message qliq_protobuf.chat.Attachment.Booking
 */
export class Attachment_Booking extends Message<Attachment_Booking> {
  /**
   * @generated from field: uint32 id = 1;
   */
  id = 0;

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  constructor(data?: PartialMessage<Attachment_Booking>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "qliq_protobuf.chat.Attachment.Booking";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Attachment_Booking {
    return new Attachment_Booking().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Attachment_Booking {
    return new Attachment_Booking().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Attachment_Booking {
    return new Attachment_Booking().fromJsonString(jsonString, options);
  }

  static equals(a: Attachment_Booking | PlainMessage<Attachment_Booking> | undefined, b: Attachment_Booking | PlainMessage<Attachment_Booking> | undefined): boolean {
    return proto3.util.equals(Attachment_Booking, a, b);
  }
}

